import React from "react";
import { motion } from "framer-motion";

import profile from "../assets/profile.png";

const Hero = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-background text-primary pt-20">
      <div className="relative z-10 grid md:grid-cols-2 items-center w-11/12 max-w-6xl gap-12 text-center md:text-left">
        {/* Left Side Content */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="flex flex-col items-center md:items-start"
        >
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.8 }}
            className="inline-flex items-center px-3 py-1 mb-6 rounded-full border border-white/10 bg-white/5 text-xs font-medium text-muted tracking-wider uppercase"
          >
            Available for Work
          </motion.div>

          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold leading-tight tracking-tight text-white mb-4">
            Hi, I'm <br />
            <span className="relative inline-block mt-1">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-white/80 relative z-10">
                Muhamad Rizky N.
              </span>
              {/* Animated Organic/Signature Underline */}
              <svg
                className="absolute -bottom-3 left-0 w-full h-4 text-accent -z-10 overflow-visible"
                viewBox="0 0 200 20"
                preserveAspectRatio="none"
              >
                <motion.path
                  d="M 2 15 C 50 5 150 25 198 10"
                  stroke="currentColor"
                  strokeWidth="6"
                  strokeLinecap="round"
                  fill="transparent"
                  initial={{ pathLength: 0 }}
                  animate={{ pathLength: 1 }}
                  transition={{ delay: 1, duration: 1, ease: "easeInOut" }}
                />
              </svg>
            </span>
          </h1>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.8 }}
            className="text-lg md:text-xl text-muted font-light max-w-lg mb-8 leading-relaxed"
          >
            Fullstack Web Developer crafting clean, functional, and digital experiences with elegant solutions.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.8 }}
            className="flex flex-col sm:flex-row gap-4"
          >
            <a
              href="#contact"
              className="px-8 py-3.5 bg-primary text-background font-medium rounded-full hover:bg-white/90 transition-all duration-300 transform hover:-translate-y-0.5"
            >
              Contact Me
            </a>
            <a
              href="https://drive.google.com/uc?export=download&id=1G_7CwBhvZvfyjVVGqyVuNaXwWTTVY8GD"
              download
              className="px-8 py-3.5 bg-transparent border border-white/20 text-primary font-medium rounded-full hover:bg-white/5 transition-all duration-300 transform hover:-translate-y-0.5"
            >
              My Resume
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8, duration: 0.8 }}
            className="flex gap-4 mt-8"
          >
            <a
              href="https://linkedin.com/in/muhamad-rizky-nurrohmat-b571922b8"
              target="_blank"
              rel="noreferrer"
              className="w-12 h-12 rounded-full border border-white/10 bg-surface flex items-center justify-center text-muted hover:text-primary hover:border-white/30 transition-all duration-300"
            >
              <i className="fab fa-linkedin text-lg"></i>
            </a>
            <a
              href="https://github.com/mrizkyn"
              target="_blank"
              rel="noreferrer"
              className="w-12 h-12 rounded-full border border-white/10 bg-surface flex items-center justify-center text-muted hover:text-primary hover:border-white/30 transition-all duration-300"
            >
              <i className="fab fa-github text-lg"></i>
            </a>
          </motion.div>
        </motion.div>

        {/* Right Side Profile - Flip Card */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="hidden md:flex justify-center md:justify-end"
        >
          <div className="relative">
            {/* Soft backdrop for image */}
            <div className="absolute inset-0 bg-gradient-to-tr from-accent/10 to-transparent rounded-3xl blur-2xl transform rotate-6 scale-105"></div>

            {/* Flip Card Container */}
            <div className="perspective cursor-pointer relative rounded-3xl overflow-hidden border border-white/10 bg-surface/50 p-2 shadow-2xl backdrop-blur-sm w-72 md:w-80 aspect-[3/4]">
              <div className="flip-card-inner">
                {/* Front - Profile Photo */}
                <div className="flip-card-front">
                  <img
                    src={profile}
                    alt="Profile"
                    className="w-full h-full rounded-2xl object-cover"
                  />
                </div>

                {/* Back - Logo */}
                <div className="flip-card-back rounded-2xl bg-gradient-to-br from-surface via-background to-surface flex items-center justify-center">
                  <div className="flex flex-col items-center gap-6">
                    <img
                      src={`${process.env.PUBLIC_URL}/logo.png`}
                      alt="Logo"
                      className="w-40 h-auto opacity-90"
                    />
                    <div className="text-center">
                      <p className="text-muted text-sm font-medium tracking-widest uppercase">Fullstack Developer</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
